import AguardandoEntregaContent from "./components/AguardandoEntregaContent";
import { AguardandoEntregaProvider } from "./context/AguardandoEntregaContext";

const AguardandoEntrega = () => (
  <AguardandoEntregaProvider>
    <AguardandoEntregaContent />
  </AguardandoEntregaProvider>
);

export default AguardandoEntrega;
